import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrChannelPartnerDeliveryStatus.ts
var t = () => e("channelPartnerDeliveryStatus");
//#endregion
export { t as useTrChannelPartnerDeliveryStatus };
